import { Box, DropProps, Text, Tip } from 'grommet';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

interface TooltipProps {
  label: string | JSX.Element;
  children: React.ReactNode;
  showToolTip?: boolean;
  dropOptions?: 'top' | 'bottom' | 'left' | 'right';
  name?: string;
  dataCy?: string;
  width?: string;
  align?: 'left' | 'center' | 'right';
}

export const StyledTooltip = ({ label, children, showToolTip = true, dropOptions, name, dataCy, width, align }: TooltipProps): JSX.Element => {
  const dropOptionsAlign: Record<string, DropProps> = {
    bottom: { align: { top: 'bottom' } },
    top: { align: { bottom: 'top' } },
    left: { align: { right: 'left' } },
    right: { align: { left: 'right' } },
  };
  const drop: DropProps = dropOptionsAlign[dropOptions ?? 'top'];

  if (!showToolTip) return <>{children}</>;
  return (
    <Tip
      plain
      key={typeof label === 'string' ? label : name ?? uuidv4()}
      dropProps={drop}
      content={
        <Box
          direction={['left', 'right'].includes(dropOptions ?? '') ? 'row' : 'column'}
          justify={'center'}
          margin={align === 'left' ? 'auto 0' : '0 auto'}
          data-cy={dataCy}
          width={width}>
          {dropOptions === 'right' && (
            <Box
              margin={'auto 0'}
              style={{
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '7.5px 10px 7.5px 0',
                borderColor: `transparent ${'#282828'} transparent transparent`,
              }}
            />
          )}
          {dropOptions === 'bottom' && (
            <Box
              margin={'0 auto'}
              style={{
                width: 0,
                height: 0,
                borderLeft: '7.5px solid transparent',
                borderRight: '7.5px solid transparent',
                borderBottom: drop?.align?.top === 'bottom' ? '10px solid #282828' : undefined,
                borderTop: drop?.align?.bottom === 'top' ? '10px solid #282828' : undefined,
              }}
            />
          )}
          <Box round={'0.25rem'} pad={'0.25rem 0.5rem'} height={'fit-content'} justify={'center'} background={{ color: '#282828' }}>
            <Text color={'#FFFFFF'} size={'0.75rem'} textAlign={'center'}>
              {label}
            </Text>
          </Box>
          {dropOptions === 'left' && (
            <Box
              margin={'auto 0'}
              style={{
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '7.5px 0 7.5px 10px',
                borderColor: `transparent transparent transparent ${'#282828'}`,
              }}
            />
          )}
          {(!dropOptions || dropOptions === 'top') && (
            <Box
              margin={'0 auto'}
              style={{
                width: 0,
                height: 0,
                borderLeft: '7.5px solid transparent',
                borderRight: '7.5px solid transparent',
                borderBottom: drop?.align?.top === 'bottom' ? '10px solid #282828' : undefined,
                borderTop: drop?.align?.bottom === 'top' ? '10px solid #282828' : undefined,
              }}
            />
          )}
        </Box>
      }>
      {children}
    </Tip>
  );
};
